import { serviceTypeService } from '../../../services/ServiceTypesService';
import { setError, setLoading, setShouldRedirect } from './ServiceTypeCreateSlice';

export const createServiceType = () => async (dispatch, getState) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));
        const { serviceTypeCreate } = getState();
        const { name } = serviceTypeCreate;
        await serviceTypeService.postServiceType(name);
        dispatch(setShouldRedirect(true));
    } catch (err) {
        dispatch(setError(err));
    } finally {
        dispatch(setLoading(false));
    }
}